import React from 'react';
import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';
import * as colors from 'src/styles/colors';

const SitemapWrapper = styled.div`
  max-width: 1000px;
  margin: 40px auto;
  padding: 0 24px;
  font-family: NotoSansTC-Medium, sans-serif;
`;

const Section = styled.section`
  margin-bottom: 32px;
  background-color: ${colors.white || '#fff'};
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
`;

const LinkList = styled.ul`
  list-style-type: none;
  padding-left: 16px;
  li {
    margin: 14px 0;
  }
  a {
    color: #0054CC;
    text-decoration: none;
    font-size: 16px;
    font-weight: bold;
    padding: 4px 8px;
    border-radius: 4px;
    &:hover, &:focus {
      text-decoration: underline;
      background-color: rgba(0, 84, 204, 0.05);
      outline: 2px solid #0054CC;
    }
  }
`;

const Sitemap: React.FC = () => {
    return (
        <SitemapWrapper>
            <h1 style={{ fontSize: '28px', color: '#333', marginBottom: '20px' }}>網站導覽 (Site Map)</h1>

            {/* 全站主要結構超連結 */}
            <Section aria-labelledby="structure-title">
                <h2 id="structure-title" style={{ fontSize: '18px', color: '#333', borderBottom: '2px solid #eee', paddingBottom: '8px', margin: '0 0 16px 0' }}>
                    網站架構連結
                </h2>
                <nav aria-label="網站架構">
                    <LinkList>
                        <li><Link to={process.env.PUBLIC_URL + "/"}>首頁</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/patentRights"}>1. 專利權證查詢</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/trademarkRights"}>2. 商標權證查詢</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/certificate/verify"}>3. 電子證書驗證</Link></li>
                    </LinkList>
                </nav>
            </Section>
        </SitemapWrapper>
    );
};

export default Sitemap;